import {
    TOUR_OPERATOR_NEW_REVIEW_SUCCESS,
    TOUR_OPERATOR_NEW_REVIEW_ERROR,
    TOUR_OPERATOR_NEW_REVIEW_START,
    TOUR_OPERATOR_PUBLISH_REVIEW_SUCCESS,
    TOUR_OPERATOR_PUBLISH_REVIEW_ERROR,
    TOUR_OPERATOR_PUBLISH_REVIEW_START,
    TOUR_OPERATOR_DECLINED_REVIEW_SUCCESS,
    TOUR_OPERATOR_DECLINED_REVIEW_ERROR,
    TOUR_OPERATOR_DECLINED_REVIEW_START
  } from '../Constants/OperatorRatingReviewsConstant'
const initialState = {
    loading: false,
    newReviewData: [],
    publishReviewData: [],
    declineReviewData: [],
};
export default function OperatorRatingReviewsReducer(state = { ...initialState }, action) {
    switch (action.type) {
        case TOUR_OPERATOR_NEW_REVIEW_START:
            return {
                ...state,
                loading: true,
            };
        case TOUR_OPERATOR_NEW_REVIEW_SUCCESS:
            return {
                ...state,
                newReviewData: action.payload,
                loading: false,
            };
        case TOUR_OPERATOR_NEW_REVIEW_ERROR:
            return {
                ...state,
                loading: false,
                message: action.error.message,
            };
        case TOUR_OPERATOR_PUBLISH_REVIEW_START:
            return {
                ...state,
                loading: true,
            };
        case TOUR_OPERATOR_PUBLISH_REVIEW_SUCCESS:
            return {
                ...state,
                publishReviewData: action.payload,
                loading: false,
            };
        case TOUR_OPERATOR_PUBLISH_REVIEW_ERROR:
            return {
                ...state,
                loading: false,
                message: action.error.message,
            };
        case TOUR_OPERATOR_DECLINED_REVIEW_START:
            return {
                ...state,
                loading: true,
            };
        case TOUR_OPERATOR_DECLINED_REVIEW_SUCCESS:
            return {
                ...state,
                declineReviewData: action.payload,
                loading: false,
            };
        case TOUR_OPERATOR_DECLINED_REVIEW_ERROR:
            return {
                ...state,
                loading: false,
                message: action.error.message,
            };
        default:
            return state;
    }
}

